/**
 * SkillDelivery Platform
 *
 * Copyright © 2026 SKD RATWANI Technology & Software Solutions Pvt Ltd
 * All Rights Reserved.
 *
 * PROPRIETARY AND CONFIDENTIAL
 */

import React from 'react';

const TYPE_STYLES = {
  individual:   { bg: '#dbeafe', fg: '#1d4ed8', label: 'Individual' },
  organization: { bg: '#dcfce7', fg: '#15803d', label: 'Organization' },
  university:   { bg: '#ede9fe', fg: '#6d28d9', label: 'University' },
  institute:    { bg: '#ffedd5', fg: '#c2410c', label: 'Institute' },
};

export default function EntityTypeBadge({ type }) {
  const key = (type || '').toLowerCase();
  const style = TYPE_STYLES[key] || { bg: '#f1f5f9', fg: '#64748b', label: type || '—' };

  return (
    <span style={{
      display: 'inline-block',
      fontSize: '11px',
      fontWeight: 600,
      padding: '2px 8px',
      borderRadius: '12px',
      background: style.bg,
      color: style.fg,
      lineHeight: 1.4,
    }}>
      {style.label}
    </span>
  );
}
